import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=b5e3407c&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"
import style0 from "./Location.vue?vue&type=style&index=0&id=b5e3407c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e3407c",
  null
  
)

export default component.exports